<template>
  <div>
    <NBar title="添加代理商" :top="true"/>
    <div class='item-div'>
      <div class='item'>
        <nut-textinput :show-icon="true" label="名称：" placeholder="请填写名称" v-model="form.name" :clearBtn="true"
                       :has-border="false" style="width: 100%;"/>
      </div>
      <div class='item'>
        <nut-textinput :show-icon="true" label="帐号：" placeholder="请填写登录帐号" v-model="form.username" :clearBtn="true"
                       :has-border="false" style="width: 100%;"/>
      </div>
      <div class='item'>
        <nut-textinput :show-icon="true" label="帐号密码：" placeholder="请填写帐号密码,不填写默认123456" v-model="form.password"
                       :clearBtn="true" type="password" :has-border="false" style="width: 100%;"/>
      </div>
      <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="openMerchant()">
        <span slot="title">选择商家</span>
        <span slot="desc">{{ merchantNames != null && merchantNames != '' ? '选择如下' : '未设置' }}</span>
      </nut-cell>
      <div v-if="merchantNames.length > 0" style="margin: 0 25px;padding-bottom: 10px;">
        <div style="height: 30px;line-height: 30px;text-align: right;color: #2d2d2d;font-size: 16px;"
             v-for="(item,index) in merchantNames">{{ item }}
        </div>
      </div>
      <!--选择商家弹窗-->
      <nut-popup v-model="showMerchant" position="bottom" closeable :style="{height: '70%'}">
        <div class="popup-top-div">
          <nut-cell style="margin-top: -3px;">
            <span slot="title" style="font-size: 16px;">选择商家</span>
          </nut-cell>
          <nut-searchbar ref="merchantSearch" @submit="merchantSearch" v-model="merchantSearchName" place-text="请输入商家名称"
                         style="margin: 10px;"/>
        </div>
        <m-list style="height:calc(100vh - 300px);margin-top: 100px" ref="merchantList" :data.sync="merchantList"
                :page.sync="merchantPage" :limit.sync="merchantLimit" @loadlist="getMerchantList">
          <div slot="list">
            <nut-cell v-for="(item ,index) in merchantList" :key="index" @click.native="merItemClick(item)">
              <span slot="title">{{ item.name }}</span>
              <span slot="desc">
                <nut-checkbox v-model="item.isCheck"/>
              </span>
            </nut-cell>
          </div>
        </m-list>
        <div class="bottom">
          <nut-button class="btn" small @click.native="merchantConfirm">确定</nut-button>
        </div>
      </nut-popup>
    </div>
    <nut-button style="margin: 30px 15px;border-radius: 5px;width:92%;" @click.native="save()">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'AgentSet',
  props: ['data'],
  data() {
    return {
      form: {
        id: null,
        merId: null,
        name: '',
        username: '',
        password: '',
        userType: 1,
        merIds: ''
      },
      //是否显示选择商家
      showMerchant: false,
      merchantList: [],
      merchantSearchName: '',
      merchantNames: [],
      merchantPage: 1,
      merchantLimit: 999,
      findMerIds: null
    }
  },
  mounted() {
    if (!this.$util.isArrOrNull (this.data)) {
      let data = JSON.parse (decodeURIComponent (this.data))
      this.$util.ofData (this.form, data)
      this.edit = true
    }
    this.getMerIds ()
  },
  methods: {
    getMerIds() {
      this.$api.post ({
        url: '/device/api/device/address/mer/find'
      }).then (res => {
        this.findMerIds = res.data
        this.getMerchantList ()
      })
    },
    merchantSearch(value) {
      this.merchantPage = 1
      this.merchantSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.merchantSearch.blur ()
      this.getMerchantList ()
    },
    openMerchant() {
      this.showMerchant = true
      this.getMerchantList ()
    },
    getMerchantList() {
      let data = {
        agentId: this.$api.agentId,
        status: 1,
        page: this.merchantPage,
        limit: this.merchantLimit
      }
      if (this.findMerIds != null) {
        data.merIds = this.findMerIds
      }
      if (this.merchantSearchName != '') {
        data.name = this.merchantSearchName
      }
      this.$api.post ({
        url: '/merchant/merchant/find/list',
        data: data
      }).then (res => {
        let merIds = this.form.merIds
        let merIdList = merIds.split (',')
        res.data.forEach ((e, index) => {
          e.isCheck = false
          merIdList.forEach (m => {
            if (e.id == m) {
              e.isCheck = true
            }
          })
        })
        this.$refs.merchantList.setRes (res)
        this.merchantNames = this.merchantList.filter (f => f.isCheck == true).map (m => m.name)
      })
    },
    merItemClick(item) {
      if (item.isCheck) {
        item.isCheck = false
      } else {
        item.isCheck = true
      }
    },
    merchantConfirm() {
      let merIds = this.merchantList.filter (f => f.isCheck == true).map (m => m.id).join (',')
      this.merchantNames = this.merchantList.filter (f => f.isCheck == true).map (m => m.name)
      this.form.merIds = merIds
      this.showMerchant = false
    },
    save() {
      if (this.form.name == '') {
        this.$toast.text ('名字不能为空')
        return
      }
      if (this.form.username == '') {
        this.$toast.text ('帐号不能为空')
        return
      }
      if (this.form.merIds == '') {
        this.$toast.text ('请选择商家')
        return
      }
      if (this.form.password == '') {
        this.form.password = '123456'
      }
      this.$api.post ({
        url: '/device/api/device/device-account/save',
        data: this.form
      }).then (res => {
        this.$toast.text ('保存成功')
        setTimeout (() => this.$router.back (), 1000)
      })
    }
  }
}
</script>

<style scoped>
.title {
  height: 35px;
  line-height: 35px;
  margin-top: 5px;
  color: #848484;
  margin-left: 20px;
}

.item-div {
  background: #fff;
}

.item-div .item {
  margin-left: 12px;
  padding-right: 12px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f9f9fb;
}

.popup-top-div {
  position: fixed;
  background: rgb(255, 255, 255);
  height: 100px;
  width: 100%;
  z-index: 1;
}

.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom .btn {
  flex: 1;
  border-radius: 0;
  height: 45px;
}

>>> .nut-checkbox input:checked {
  background-color: #007aff;
  border-color: #007aff;
}

>>> .nut-checkbox input:after {
  background: #007aff;
}

>>> .nut-button {
  background: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/AgentSet.vue